module.exports = __webpack_public_path__ + "static/media/providers.ff5f6e02.svg";